// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1osq{width:100%}
._4t3i1osq{height:100%}
._80omtlke{cursor:pointer}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/customMediaPlayer/playPauseBlanket-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,UAAU;AACrB,WAAW,WAAW;AACtB,WAAW,cAAc","sourcesContent":["._1bsb1osq{width:100%}\n._4t3i1osq{height:100%}\n._80omtlke{cursor:pointer}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
